import React from 'react'

export const TextSettings = (settingsProps) => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
